module.exports = __webpack_public_path__ + "static/media/thumbnail.759812e2.jpg";